var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex-index"},[_c('tracking'),_c('input-shipping-check-price',{staticClass:"cek-tariff",on:{"click":_vm.goingToTrack}}),_c('location-agent')],1)}
var staticRenderFns = []

export { render, staticRenderFns }